import React, { useEffect, useRef, useState } from "react";
import {
  NavLink,
  useNavigate,
  useLocation,
  useParams,
  Link,
} from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { API_BASE_URL, Assets_URL } from "../Apicongfig";
import { useDraftMeetings } from "../../context/DraftMeetingContext";
import { CiLogout, CiUser } from "react-icons/ci";
import axios from "axios";
import { useUser } from "../../context/UserContext";
import { useTabs } from "../../context/TabContext";
import { useSidebarContext } from "../../context/SidebarContext";
import { useDestinations } from "../../context/DestinationsContext";
import { useEnterpriseCount } from "../../context/EnterpriseUserCountContext";
import { Badge } from "react-bootstrap";
import { useHeaderTitle } from "../../context/HeaderTitleContext";

function MobileSidebar({
  isSidebarOpen,
  toggleSidebar,
  onLogout,
  open,
  handleClose,
}) {
  const { activeTab, setActiveTab } = useTabs();
  // const { user } = useUser();
  const [t, i18n] = useTranslation("global");
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { userHaveMeetings,userHaveSteps } = useDestinations();
  const { enterpriseCount, fetchEnterpriseCount } = useEnterpriseCount();

  const { show } = useSidebarContext();

    useEffect(() => {
      fetchEnterpriseCount();
    }, [location.pathname]);
  const isActiveContract = [
    `/contract`,
    "/ModifierContract",
    "/ContractLinkEntreprises",
    "/ContractToTeam",
    `/readContract/${params.id}`,
    `/ModifierContract/${params.id}`,
    `/CopyContract/${params.id}`,
    `/CopyClosedContract/${params.id}`,
  ].includes(location.pathname);

  const isActiveEntreprises = [
    `/Enterprises`,
    "/ModifierEnterprises",
    "/EntreprisesToTeam",
    `/ModifierEnterprises/${params.id}`,
  ].includes(location.pathname);

  const isActiveTeam = [
    `/Team`,
    `/ModifierTeam/${params.id}`,
    `/users/${params.id}`,
    `/ModifierUser/${params.id}`,
  ].includes(location.pathname);

  const isActiveSupport = [`/customer-support`].includes(location.pathname);

  const isActiveMeeting =
    location.pathname.startsWith("/meeting") ||
    location.pathname.startsWith("/graph") ||
    location.pathname.startsWith("/view") ||
    location.pathname.startsWith("/copy") ||
    location.pathname.startsWith("/d") ||
    location.pathname.startsWith("/Play") ||
    location.pathname.startsWith("/presentation") ||
    location.pathname.startsWith("/validateMeeting") ||
    location.pathname.startsWith("/meetings/drafts") ||
    location.pathname.startsWith("/present/invite") ||
    location.pathname.startsWith("/invite");

  const isActiveAction = location.pathname.startsWith("/action");
  const isActiveDiscussion = [`/discussion`].includes(location.pathname);

  const isActiveSolution = location.pathname.startsWith("/solution");

  const isActiveGuest = [
    "/Invities",
    `/invitiesToMeeting/${params.id}`,
    `/participantToAction/${params.id}`,
    `/updateParticipant/${params.id}`,
  ].includes(location.pathname);

  // Check if the current route matches either `/newsletter/terms-and-conditions`
  // or `destination/:unique_id/:id`
  const hideSidebar =
    location.pathname === "/newsletter/terms-and-conditions" ||
    /^\/destination\/[^/]+\/[^/]+$/.test(location.pathname);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    }
    //toast.success(t("header.logoutSuccess"));
    navigate("/");
  };
  const role = sessionStorage.getItem("type");

  // const { profileImage, setProfileImage } = useHeaderTitle();
    const { setUser, user,callUser } = useHeaderTitle();
  
  const [profileImage, setProfileImage] = useState(null);

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const dropdownRef = useRef(null);

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      closeDropdown();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  
  const userID = sessionStorage.getItem("user_id");
  useEffect(() => {
    const getUser = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/users/${userID}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        if (response.status === 200) {
          setUser(response?.data?.data);
          // console.log("response in header", response);
          setProfileImage(response.data.data?.image);
        }
      } catch (error) {
        // console.log(error?.message);
      }
    };
    if (userID) {
      getUser();
    }
  }, [callUser]);
  const iconStyle = {
    fill: " #5088ee",
    width: "50px",
    height: "50px",
    background: "azure",
    borderRadius: "50%",
    cursor: "pointer",
  };



  const isActive = (paths) => paths.some((p) => location.pathname.startsWith(p));
  const jobTabOrder = {
    "Project Manager / Product Owner": ["missions", "moments"],
    "Developer / Operational Contributor": ["actions", "moments"],
    "Trainer / Coach": ["moments", "solutions"],
    "Customer Relations Officer / Sales Representative": ["missions", "moments"],
    "Manager / Team Leader": ["casting", "moments"],
    "Consultant / Freelance": ["missions","moments"],
    "Other / Explorer": [ "moments"],
  };
  
  const needsToTabMap = {
    casting_need: "casting",
    meeting_need: "moments",
    mission_need: "missions",
    action_need: "actions"
    // solutions doesn't have a corresponding need
  };
  
  
  const tabsToRender = React.useMemo(() => {
    // Get user's job or default to "Other/Explorer"
    const job = user?.job || "Other / Explorer";
    // Get tabs for the job or default tabs
    let tabs = jobTabOrder[job] || jobTabOrder["Other / Explorer"];
    
    // Special handling for admin roles:
    // Always include 'casting' tab at beginning if not already present
    const isAdminRole = ["Admin", "MasterAdmin", "SuperAdmin"].includes(role);
    if (isAdminRole && !tabs.includes("casting")) {
      tabs.unshift("casting");
    }
  
    // If user has no needs, return the default tabs for their job
    if (!user?.user_needs || user?.user_needs?.length === 0) {
      return tabs;
    }
  
    // Process user needs:
    // 1. Extract active needs from user data
    const activeNeeds = user.user_needs.map(item => item.need);
    // 2. Map needs to corresponding tabs
    const neededTabs = activeNeeds.map(need => needsToTabMap[need]).filter(Boolean);
    
    // For admin roles:
    // Combine casting tab with any other needed tabs (removing duplicates)
    if (isAdminRole) {
      return Array.from(new Set([...tabs.filter(tab => tab === "casting"), ...neededTabs]));
    }
  
    // For regular users:
    // If they have active needs, show only tabs that match those needs
    // Otherwise show default tabs for their job
    return neededTabs.length > 0 
      ? tabs.filter(tab => neededTabs.includes(tab))
      : tabs;
  }, [user?.job, user?.user_needs, role, userID, user]); // Dependencies for React memo
  // Enhanced renderNavTab with additional logging for debugging
  
  
  
  // Enhanced renderNavTab with additional logging for debugging
  const renderNavTab = (tab) => {
    console.log('Rendering tab:', tab, 'for needs:', user?.user_needs);
    
    switch (tab) {
      case "casting":
        // Always show if user's role name is Admin
    if (role === "Admin" || role === "MasterAdmin" || role === "SuperAdmin" || (role !== "User" && role !== "Invitee")) {
      return (
        <NavLink className={`nav-link ${isActive(["/Team", "/ModifierTeam", "/users", "/ModifierUser"]) ? "active" : ""}`} 
          to="/Team" 
          onClick={() => { 
            setDropdownOpen(false); 
            sessionStorage.setItem("activeTab", "tab5"); 
            sessionStorage.setItem("missionTab", "Schedule monitoring"); 
          }}>
          <button>
            <img src={isActive(["/Team", "/ModifierTeam", "/users", "/ModifierUser"]) ? "/Assets/sidebar_team_active.svg" : "/Assets/sidebar_team.svg"} alt="team" />
            <span>{t("sidebar.teams")}</span>
          </button>
        </NavLink>
      );
    }
        break;
  
      case "missions":
        return (
          <NavLink className={`nav-link ${isActive(["/Invities", "/invitiesToMeeting", "/participantToAction", "/updateParticipant"]) ? "active" : ""}`} 
            to="/Invities" 
            onClick={() => { 
              setDropdownOpen(false); 
              sessionStorage.setItem("activeTab", "tab5"); 
              sessionStorage.setItem("missionTab", "Schedule monitoring"); 
            }}>
            <button>
              <img src={isActive(["/Invities", "/invitiesToMeeting", "/participantToAction", "/updateParticipant"]) ? "/Assets/sidebar_active_destination.svg" : "/Assets/sidebar_destination.svg"} alt="destination" />
              <span>{t("sidebar.guests")}</span>
            </button>
          </NavLink>
        );
  
      case "actions":
        // if (role !== "User" && role !== "Invitee" && userHaveSteps > 0) {
          return (
            <NavLink className={`nav-link ${isActive(["/action", "/step"]) ? "active" : ""}`} 
              to="/action" 
              onClick={() => { 
                setDropdownOpen(false); 
                sessionStorage.setItem("activeTab", "tab5"); 
                sessionStorage.setItem("missionTab", "Schedule monitoring"); 
              }}>
              <button>
                <img src={isActive(["/action", "/step"]) ? "/Assets/sidebar-action-active.svg" : "/Assets/sidebar-action.svg"} alt="action" />
                <span>{t("sidebar.action")}</span>
              </button>
            </NavLink>
          );
        // }
        break;
  
      case "moments":
        // if (role !== "User" && role !== "Invitee" && userHaveMeetings > 0) {
          return (
            <NavLink className={`nav-link ${isActive(["/meeting", "/graph", "/view", "/copy", "/Play", "/presentation", "/validateMeeting", "/meetings/drafts", "/present/invite", "/invite"]) ? "active" : ""}`} 
              to="/meeting" 
              onClick={() => { 
                setDropdownOpen(false); 
                sessionStorage.setItem("activeTab", "tab5"); 
                sessionStorage.setItem("missionTab", "Schedule monitoring"); 
                setActiveTab("tab2");
              }}>
              <button>
                <img src={isActive(["/meeting", "/graph", "/view", "/copy", "/Play", "/presentation", "/validateMeeting", "/meetings/drafts", "/present/invite", "/invite"]) ? "/Assets/sidebar_meeting_active.svg" : "/Assets/sidebar_meeting.svg"} alt="meeting" />
                <span>{t("sidebar.meetings")}</span>
              </button>
            </NavLink>
          );
        // }
        break;
  
      case "solutions":
        if (role !== "Invitee") {
          return (
            <NavLink className={`nav-link ${isActive(["/solution"]) ? "active" : ""}`} 
              to="/solution" 
              onClick={() => { 
                setDropdownOpen(false); 
                sessionStorage.setItem("activeTab", "tab5"); 
                sessionStorage.setItem("missionTab", "Schedule monitoring"); 
              }}>
              <button>
                <img src={isActive(["/solution"]) ? "/Assets/Tek.png" : "/Assets/tektime-sidebar.svg"} alt="solution" width="32px" />
                <span>{t("sidebar.solution")}</span>
              </button>
            </NavLink>
          );
        }
        break;
  
      default:
        return null;
    }
  };
  
    // Don't render the sidebar if the route matches the specified conditions
  if (hideSidebar) {
    return null; // Return null to not render the sidebar
  }

  return (
    <>
      <div className="sidebar1" id="sidebar" style={{ display: show ? "block" : "none" }}>
            <div className="container-fluid">
              <div className="text-center p-4">
                <div className="profile-logo">
                  {profileImage ? (
                    <img className="user-img" src={profileImage?.startsWith("users/") ? `${Assets_URL}/${profileImage}` : profileImage} alt="profile" onClick={() => setDropdownOpen(!isDropdownOpen)} style={{ cursor: "pointer" }} />
                  ) : (
                    <svg className="user-img" onClick={() => setDropdownOpen(!isDropdownOpen)} style={{ fill: "#5088ee", width: "50px", height: "50px", background: "azure", borderRadius: "50%", cursor: "pointer" }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                    </svg>
                  )}
                  <img className="logout-icon" src="/Assets/Avatar_company.svg" height="12px" width="12px" alt="tektime" />
                </div>
                {isDropdownOpen && (
                  <div className="dr" ref={dropdownRef}>
                    <div className="dropdown-arrow-up"></div>
                    <div className="dropdown-item" onClick={() => { navigate("/profile"); sessionStorage.setItem("activeTab", "tab5"); sessionStorage.setItem("missionTab", "Schedule monitoring"); setDropdownOpen(false); }}>
                      <div style={{ borderBottom: "1px solid #D5D5D5", width: "100%", textAlign: "left", paddingBottom: "9px" }}>
                        <span role="img" aria-label="Profile">
                          <img src="/Assets/sidebar_profile.svg" alt="profile" />
                        </span>
                        <span className="dropdown-profile">{t("sidebar.profile")}</span>
                      </div>
                    </div>
                    <div className="dropdown-item" onClick={() => { handleLogout(); setDropdownOpen(false); }}>
                      <span role="img" aria-label="Logout" className="me-3"><CiLogout /></span>
                      <span className="dropdown-logout">{t("sidebar.logout")}</span>
                    </div>
                  </div>
                )}
              </div>
              <div className="side-btn">
                <div style={{ position: "absolute", top: role === "MasterAdmin" ? "15%" : "25%", width: "100%" }}>
                  
                {role === "MasterAdmin" && (
                  <NavLink
                    className={`nav-link ${isActive(["/contract"]) ? "active" : ""}`}
                    to="/contract"
                    onClick={() => {
                      setDropdownOpen(false);
                      sessionStorage.setItem("activeTab", "tab5");
                      sessionStorage.setItem("missionTab", "Schedule monitoring");
                    }}
                  >
                    <button>
                      <img
                        src={isActive(["/contract"]) ? "/Assets/sidebar_subscription_active.svg" : "/Assets/sidebar_subscription.svg"}
                        alt="subscription"
                      />
                      <span>{t("sidebar.subscriptions")}</span>
                    </button>
                  </NavLink>
                )}
                    {(role === "MasterAdmin" || role === "SuperAdmin") && (
                  <NavLink
                    className={`nav-link ${isActive(["/Enterprises"]) ? "active" : ""}`}
                    to="/Enterprises"
                    onClick={() => {
                      setDropdownOpen(false);
                      sessionStorage.setItem("activeTab", "tab5");
                      sessionStorage.setItem("missionTab", "Schedule monitoring");
                    }}
                    style={{position:'relative'}}
                  >
                    <button>
                      <img
                        src={isActive(["/Enterprises"]) ? "/Assets/sidebar_enterprise_active.svg" : "/Assets/sidebar_enterprise.svg"}
                        alt="enterprise"
                      />
                      <span>{t("sidebar.enterprises")}</span>
                      {enterpriseCount > 0 && (
                        <Badge
                          pill
                          bg={isActive(["/Enterprises"]) ? "light" : "primary"}
                          text={isActive(["/Enterprises"]) ? "dark" : "white"}
                          style={{
                            position: "absolute",
                            right: "10px",
                            fontSize: "0.65rem",
                            padding: "4px 6px",
                            minWidth: "20px",
                            lineHeight: "1",
                            fontWeight: "600",
                            boxShadow: "0 0 0 2px rgba(255,255,255,0.8)",
                            transition: "all 0.2s ease",
                            transform: "translateY(-42px)",
                            top: "50%",
                          }}
                        >
                          {enterpriseCount}
                        </Badge>
                      )}
                    </button>
                  </NavLink>
                )}
      
                  {tabsToRender?.map((tab) => (
                    <React.Fragment key={tab}>{renderNavTab(tab)}</React.Fragment>
                  ))}
                </div>
              </div>
            </div>
          </div>
    </>
  );
}
export default MobileSidebar;
